import script from "./siddar-summary-report.vue?vue&type=script&setup=true&lang=ts"
export * from "./siddar-summary-report.vue?vue&type=script&setup=true&lang=ts"

import "./siddar-summary-report.vue?vue&type=style&index=0&id=6123950c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6123950c"]])

export default __exports__